import UserProfilePage from "pages/UserProfilePage";
import React from "react";

const UserProfileRoute = () => <UserProfilePage />;

export default UserProfileRoute;
